import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/availableBalanceSummaryCard.module.scss';

function ThresholdProgressSection({ thresholdPercent = 0 }) {
    const clamped = Math.min(100, Math.max(0, Number(thresholdPercent) || 0));

    return (
        <div className={styles.thresholdBlock}>
            <div className={styles.thresholdHeader}>
                <Text as="span" size="xs" className={styles.thresholdLabel}>
                    Current Threshold
                </Text>
                <Text as="span" size="s" className={styles.thresholdPercent}>
                    {clamped.toFixed(0)}%
                </Text>
            </div>
            <div className={styles.thresholdBarTrack}>
                <div
                    className={styles.thresholdBarFill}
                    style={{ width: `${clamped}%` }}
                    role="progressbar"
                    aria-valuenow={clamped}
                    aria-valuemin={0}
                    aria-valuemax={100}
                />
            </div>
        </div>
    );
}

export default ThresholdProgressSection;
